import React from "react";

const Donate = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="skeleton h-64 w-64"></div>
    </div>
  );
};

export default Donate;
